import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAttachmentList } from '#/graphql/queries';
import type {
  GetAttachmentListQuery,
  GetAttachmentListQueryVariables,
  SortByParams,
} from '#/graphql/types';

const q = gql(getAttachmentList);

export interface AttachmentsQueryVars {
  filter?: string;
  sortBy?: SortByParams;
}

const useGetAttachmentsList = (vars: AttachmentsQueryVars = {}) => {
  const query: QueryResult<GetAttachmentListQuery, GetAttachmentListQueryVariables> = useQuery(q, {
    variables: {
      params: {
        filter: vars.filter,
        sortBy: vars.sortBy,
      },
    },
  });

  return query;
};

export default useGetAttachmentsList;
